import React from 'react';

import { useOnClickOutside } from 'usehooks-ts';

export const useEditorRefs = ({ onOutsideClick }: { onOutsideClick: () => void }) => {
  const editorRef = React.useRef<HTMLDivElement | null>(null);
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const portalRef = React.useRef<HTMLDivElement | null>(null);
  const toolbarRef = React.useRef<HTMLDivElement | null>(null);

  useOnClickOutside([containerRef, portalRef, toolbarRef], onOutsideClick);

  return {
    editorRef,
    containerRef,
    portalRef,
    toolbarRef,
  };
};
